import { useContent } from "contexts/contentContext/contentContext.js";
import React from "react";

const JumboPayTableHeader = ({ headerTable }) => {
  const { getTextByKey } = useContent();
  return (
    <div className="header-table">
      {headerTable.map((item, i) => (
        <div key={i} className={`header-item ${item.className}`}>
          {getTextByKey(item.constName)}
        </div>
      ))}
    </div>
  );
};

export default JumboPayTableHeader;
